import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-50 py-12">
      <div className="travel-container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Travel Services Section */}
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold mb-6 uppercase tracking-wider text-gray-900 border-b border-gray-200 pb-2">
              Travel Services
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigate("/flights")}
                  className="text-gray-600 hover:text-travel-blue transition-colors"
                >
                  Flight Search
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/hotels")}
                  className="text-gray-600 hover:text-travel-blue transition-colors"
                >
                  Hotel Bookings
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/weather")}
                  className="text-gray-600 hover:text-travel-blue transition-colors"
                >
                  Weather Forecast
                </button>
              </li>
            </ul>
          </div>

          {/* Planning Tools Section */}
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold mb-6 uppercase tracking-wider text-gray-900 border-b border-gray-200 pb-2">
              Planning Tools
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigate("/itinerary")}
                  className="text-gray-600 hover:text-travel-blue transition-colors"
                >
                  Itinerary Generator
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/assistant")}
                  className="text-gray-600 hover:text-travel-blue transition-colors"
                >
                  AI Travel Assistant
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © 2025 TravelAI by RISHI-125073. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm mt-2 md:mt-0">
              Powered by AI for smarter travel planning.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
